import { render, staticRenderFns } from "./ImageMenuUploader.vue?vue&type=template&id=b681b670&scoped=true&"
import script from "./ImageMenuUploader.vue?vue&type=script&lang=js&"
export * from "./ImageMenuUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImageMenuUploader.vue?vue&type=style&index=0&id=b681b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b681b670",
  null
  
)

export default component.exports